import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { TypeConges } from '../model/type-conges';

@Injectable({
    providedIn: 'root'
  })
  export class TypeCongesService{
  
  constructor(private _restClientService : RestClientService) 
  {}
  
  getAll() 
  {
    return this._restClientService.load<TypeConges[]>('type-conges/get-all');
  }
  
}      

    